<template>
  <ul>
    <li>
      <p>MY쇼핑</p>
      <ul class="menu">
        <li>
          <a @click.prevent="navigateTo('/mypage/order-list')">주문조회</a>
        </li>
        <!-- <li><a @click.prevent="navigateTo('/mypage/cancel-list')">취소내역</a></li> -->
        <li>
          <a @click.prevent="navigateTo('/mypage/account-management')"
            >환불계좌관리</a
          >
        </li>
      </ul>
    </li>
    <li>
      <p>활동내역</p>
      <ul class="menu">
        <li>
          <a @click.prevent="navigateTo('/mypage/inquiry-list')">1:1문의내역</a>
        </li>
        <li>
          <a @click.prevent="navigateTo('/mypage/my-review')">나의상품평</a>
        </li>
      </ul>
    </li>
    <li>
      <p>정보수정</p>
      <ul class="menu">
        <li>
          <a @click.prevent="navigateTo('/mypage/edit-profile')"
            >회원정보변경</a
          >
        </li>
        <li>
          <a @click.prevent="navigateTo('/mypage/change-pwd')">비밀번호변경</a>
        </li>
        <li>
          <a @click.prevent="navigateTo('/mypage/sns-connection-setting')"
            >SNS연결설정</a
          >
        </li>
        <li>
          <a @click.prevent="navigateTo('/mypage/delete-account')">회원탈퇴</a>
        </li>
        <li>
          <a @click="logout">로그아웃</a>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
import { mapActions } from 'vuex';

const accountModule = 'accountModule'

export default {
  methods: {
    ...mapActions(accountModule, ['requestLogout']),

    navigateTo(path) {
      this.$router.push(path);
    },

    async logout() {
      await this.requestLogout()
      this.$openModal('alertModal', {
        message: '로그아웃 됐습니다.'
      })
      this.$router.push({ name: 'home' })
    }
  },
};
</script>
<style lang=""></style>
